import { Typography } from '@/components/Typography'
import styles from './ArticleDetailHeadItemDay.module.scss'

export type DayItemHeadProps = {
  readonly items: Array<{
    readonly model: {
      readonly publishedAt: string
      readonly headline: string
    }
  }>
}

export default function WidgetArticleDetailFooterItemDay({ item }: { readonly item: DayItemHeadProps }) {
  const article = item.items?.[0]
  const current = new Date(article.model.publishedAt)
  const dateTime = current.toLocaleString('de-DE', {
    hour: '2-digit',
    minute: '2-digit',
  })
  return (
    <div className={styles.head}>
      <span className={styles.date}>{dateTime} Uhr</span>
      <h2 className={styles.headline}>{article.model.headline}</h2>
    </div>
  )
}
